import React, { useState, useEffect } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import {
  LightIcon,
} from "../../../AssetComponents/Images"
import {
  EmptyBooking,
  EmptyInbox,
  EmptyWishlist,
  UnVerified,
  VerifyUserIcon,
  UserBoxIcon,
} from "../../../AssetComponents/Images"
import Veified from "../../../Components/DashBoardSvg/Veified"
import { BlackButton } from "../../../Components/Buttons/BlackButton"
import { PurpleButton } from "../../../Components/Buttons/PurpleButton"
import { RentalItem } from "../../../Components/RealEstateProperty/RentalItem"
import { SelectionGroup, SelectionItem } from "../../../Components/Selection/Selection"
import { StaticTravelerSidebar } from "./SideBar"
import { OnboardingProvider, useOnboarding } from '../OnBoarding1'
import { toast } from '../Toast'
import Modal from 'react-responsive-modal'
import { Header } from '../FakeHeader'
import { useIsMobile } from '../UseIsMobile'
import Logo1 from '../../../assets/images/logoForQRcode.svg'


// Static data for traveler
const staticProfile = {
  Avatar: "/placeholder.svg?height=80&width=80",
  Name: "WELHOME",
  ID: "unverified/account",
}

const staticWishlist = [
  {
    token_id: "1",
    metaData: {
      buildingName: "Luxury Apartment Downtown",
      images: ["/placeholder.svg?height=200&width=300"],
    },
  },
  {
    token_id: "2",
    metaData: {
      buildingName: "Modern Studio Apartment",
      images: ["/placeholder.svg?height=200&width=300"],
    },
  },
  {
    token_id: "3",
    metaData: {
      buildingName: "Cozy Mountain Cabin",
      images: ["/placeholder.svg?height=200&width=300"],
    },
  },
]

// Create a wrapper component that provides the onboarding context
export const TravelerDashboard = () => {
  return (
    <OnboardingProvider>
      <TravelerDashboardContent />
    </OnboardingProvider>
  )
}

// Rename the main component to avoid conflicts
const TravelerDashboardContent = () => {
  const [searchParams] = useSearchParams()
  const { 
    isOnboarding, currentStep, nextStep, prevStep, skipOnboarding, completeOnboarding, 
    setCurrentStep, startOnboarding, showConfirmModal, pendingNavigation, requestTourSwitch, 
    confirmTourSwitch, cancelTourSwitch 
  } = useOnboarding()
  const navigate = useNavigate()

  const currentProfile = staticProfile
  const wishlistItems = staticWishlist
  const flag = 0 // Default to "Upcoming" tab
  const isMobile = useIsMobile();
  // Sidebar onboarding step logic
  useEffect(() => {
    const stepParam = searchParams.get('step');
    const pathname = window.location.pathname;

    // Show sidebar modal for traveler onboarding step 13
    // Also show sidebar modal if coming from host route with step=13
    if (
      stepParam === '13' &&
      (
        pathname.includes('/onboarding/traveller') ||
        pathname.includes('/onboarding/host')
      )
    ) {
      startOnboarding();
      setCurrentStep(13);
    }
    else if (stepParam === '14') {
      startOnboarding();
      setCurrentStep(14);
    }
    else if (stepParam === '15') {
      startOnboarding();
      setCurrentStep(15);
    }
    else if (stepParam === '16') {
      startOnboarding();
      setCurrentStep(16);
    }
    else if (stepParam === '17') {
      startOnboarding();
      setCurrentStep(17);
    }
    else if (stepParam === '18') {
      startOnboarding();
      setCurrentStep(18);
    }
    // If no step, start at sidebar onboarding step (step 13)
    else if (!stepParam) {
      startOnboarding();
      setCurrentStep(13);
    }
  }, [searchParams.get('step'), window.location.pathname]); // Only depend on step param

  const handleSkipOnboarding = () => {
    skipOnboarding();
    navigate('/rent/all');
  };



 

  return (
    <>
            {isMobile ? (
          <>
            {showConfirmModal && currentStep === 18 && (
              <Modal
                open={true}
                center
                onClose={() => {}}
                showCloseIcon={false}
                classNames={{
                  modal: "rounded-xl border-none shadow-2xl onboarding-highlight max-w-[95vw] bg-white",
                }}
                styles={{
                  modal: {
                    zIndex: 9999,
                    maxHeight: '90vh',
                    overflow: 'hidden',
                    backgroundColor: '#ffffff',
                    background: '#ffffff',
                  },
                }}
              >
                <div className="relative flex flex-col max-h-[90vh]">
                  {/* Header */}
                  <div className="bg-gradient-to-r from-purple-600 via-purple-700 to-purple-800 p-3 text-center text-white flex-shrink-0">
                    <div className="flex justify-center mb-2">
                      <div className="bg-white rounded-full p-1.5">
                        <img
                          src={Logo1}
                          alt="CodedEstate Logo"
                          className="w-8 h-8"
                        />
                      </div>
                    </div>
                    <h1 className="text-base font-bold mb-1">
                      Welcome to Traveling on CodedEstate!
                    </h1>
                    <p className="text-purple-100 text-xs">
                      Discover the future of real estate rentals as a Traveler
                    </p>
                  </div>

                  {/* Content */}
                  <div className="p-3 bg-white flex-1 overflow-y-auto">
                    <div className="text-center mb-3">
                      <h2 className="text-sm font-semibold text-gray-800 mb-1">
                        Why travel with CodedEstate?
                      </h2>
                      <p className="text-gray-600 text-xs leading-snug">
                        Book unique properties, pay with crypto, and enjoy seamless travel experiences
                      </p>
                    </div>

                    {/* Features - Compact list */}
                    <div className="mb-3 text-left">
                      <ul className="list-disc pl-4 text-gray-700 space-y-0.5 text-xs">
                        <li><span className="font-semibold text-purple-700">Book unique properties</span> worldwide</li>
                        <li><span className="font-semibold text-purple-700">Pay with crypto</span> securely</li>
                        <li><span className="font-semibold text-purple-700">Direct booking</span> with hosts</li>
                        <li><span className="font-semibold text-purple-700">Manage trips</span> easily</li>
                        <li><span className="font-semibold text-purple-700">Save favorites</span> for future trips</li>
                        <li><span className="font-semibold text-purple-700">Reduced fees</span> – no middlemen</li>
                        <li><span className="font-semibold text-purple-700">Blockchain-secure</span> transactions</li>
                        <li><span className="font-semibold text-purple-700">Global access</span> to properties</li>
                        <li><span className="font-semibold text-purple-700">Messaging</span> with hosts</li>
                        <li><span className="font-semibold text-purple-700">Trip insights</span> and notifications</li>
                      </ul>
                    </div>

                    {/* Buttons - Single line */}
                    <div className="onboarding-modal-buttons flex-shrink-0">
                      <BlackButton
                        text="Skip Tour"
                        onClick={handleSkipOnboarding}
                        className="px-3 py-1.5 text-xs"
                      />
                      <PurpleButton
                        text={
                          <div className="flex items-center gap-1">
                            <span>Start Tour</span>
                            <svg
                              className="w-3 h-3"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path
                                fillRule="evenodd"
                                d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                                clipRule="evenodd"
                              />
                            </svg>
                          </div>
                        }
                        onClick={() => {
                          navigate('/onboarding/traveller?step=13');
                          nextStep();
                        }}
                        className="px-3 py-1.5 text-xs"
                      />
                    </div>

                    {/* Footer */}
                    <div className="text-center mt-2 flex-shrink-0">
                      <p className="text-[10px] text-gray-500">
                        This tour shows how to travel in under 2 minutes
                      </p>
                    </div>
                  </div>
                </div>
              </Modal>
            )}

        {/* Onboarding backdrops */}
        {isOnboarding && currentStep === 13 && (
          <div className="fixed inset-0 bg-black bg-opacity-30 z-[99998] pointer-events-none" />
        )}
        {isOnboarding && currentStep === 14 && (
          <div className="fixed inset-0 bg-black bg-opacity-30 z-[99998] pointer-events-none" />
        )}
        {isOnboarding && currentStep === 15 && (
          <div className="fixed inset-0 bg-black bg-opacity-30 z-[99998] pointer-events-none" />
        )}
        {isOnboarding && currentStep === 16 && (
          <div className="fixed inset-0 bg-black bg-opacity-30 z-[99998] pointer-events-none" />
        )}
        {isOnboarding && currentStep === 17 && (
          <div className="fixed inset-0 bg-black bg-opacity-30 z-[99998] pointer-events-none" />
        )}
        {isOnboarding && currentStep === 18 && (
          <div className="fixed inset-0 bg-black bg-opacity-30 z-[99998] pointer-events-none" />
        )}

           <div className="flex h-screen">
        <div className={`relative ${isOnboarding && currentStep === 13 ? 'ring-4 ring-purple-500 ring-opacity-50' : ''}`}>
          <StaticTravelerSidebar />
          
       
          {isOnboarding && currentStep === 13 && (
            <div className="absolute ml-15 top-8 left-4 w-[200px] bg-white rounded-lg shadow-2xl border-4 border-purple-500 z-[99999] onboarding-highlight pointer-events-auto">
              <div className="p-2">
                <div className="text-center mb-2">
                  <h3 className="text-sm font-semibold">Navigation Sidebar</h3>
                  <p className="text-[10px] text-[#666666] mt-1">Your menu for key features</p>
                </div>
                <div className="bg-purple-50 p-1.5 rounded-lg border border-purple-200 mb-2">
                  <div className="flex items-center gap-1 mb-1">
                    <div className="w-1.5 h-1.5 bg-purple-500 rounded-full"></div>
                    <div className="text-[10px] font-semibold text-purple-800">Traveler Navigation</div>
                  </div>
                  <div className="text-[8px] text-purple-700">
                    Your home base for traveling
                  </div>
                </div>
                <div className="space-y-0.5 mb-2">
                  <div className="flex items-center gap-1.5 p-1 bg-blue-50 rounded">
                    <div className="w-3 h-3 bg-blue-500 rounded-full flex items-center justify-center text-white">
                      <svg className="w-1.5 h-1.5" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
                      </svg>
                    </div>
                    <div>
                      <div className="text-[10px] font-semibold">Dashboard</div>
                      <div className="text-[8px] text-[#666666]">Home base</div>
                    </div>
                  </div>
                  <div className="flex items-center gap-1.5 p-1 bg-green-50 rounded">
                    <div className="w-3 h-3 bg-green-500 rounded-full flex items-center justify-center text-white">
                      <svg className="w-1.5 h-1.5" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <div>
                      <div className="text-[10px] font-semibold">Trips</div>
                      <div className="text-[8px] text-[#666666]">Bookings</div>
                    </div>
                  </div>
                  <div className="flex items-center gap-1.5 p-1 bg-yellow-50 rounded">
                    <div className="w-3 h-3 bg-yellow-500 rounded-full flex items-center justify-center text-white">
                      <svg className="w-1.5 h-1.5" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z" />
                      </svg>
                    </div>
                    <div>
                      <div className="text-[10px] font-semibold">Transactions</div>
                      <div className="text-[8px] text-[#666666]">Payments</div>
                    </div>
                  </div>
                  <div className="flex items-center gap-1.5 p-1 bg-red-50 rounded">
                    <div className="w-3 h-3 bg-red-500 rounded-full flex items-center justify-center text-white">
                      <svg className="w-1.5 h-1.5" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                        <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                      </svg>
                    </div>
                    <div>
                      <div className="text-[10px] font-semibold">Inbox</div>
                      <div className="text-[8px] text-[#666666]">Messages</div>
                    </div>
                  </div>
                </div>
                <div className="bg-gradient-to-r from-purple-50 to-blue-50 p-1.5 rounded border border-purple-200 mb-2">
                  <div className="flex items-center gap-1 mb-1">
                    <div className="w-1.5 h-1.5 bg-gradient-to-r from-purple-500 to-blue-500 rounded-full"></div>
                    <div className="text-[10px] font-semibold text-purple-800">Role Switcher</div>
                  </div>
                  <div className="text-[8px] text-purple-700">
                    🔄 Switch Host/Traveler at bottom
                  </div>
                </div>
                <div className="absolute top-1/2 -left-3 w-0 h-0 border-r-[12px] border-t-[8px] border-b-[8px] border-r-purple-500 border-t-transparent border-b-transparent"></div>
                <div className="onboarding-modal-buttons">
                  <BlackButton 
                    text="Back"
                    onClick={() => {
                      navigate('/onboarding/traveller?step=13');
                      prevStep();
                    }}
                    className="text-[10px] py-1 px-1.5 flex-1"
                  />
                  <PurpleButton 
                    text="Next"
                    onClick={() => {
                      navigate('/onboarding/traveller?step=14');
                      nextStep();
                    }}
                    className="text-[10px] py-1 px-1.5 flex-1"
                  />
                  <button 
                    onClick={handleSkipOnboarding}
                    className="px-1.5 py-1 text-[8px] text-gray-500 hover:text-gray-700 rounded transition-colors"
                  >
                    Skip
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
        

        {/* Main Content */}
        <div className="flex-1 select-none w-full overflow-auto max-h-[calc(100vh-80px)] h-full p-[10px]">
            <div className="w-full h-full space-y-[20px] rounded-[10px] p-[8px] flex flex-col">
               {/* Header */}
            <div className="bg-white border-[2px] h-max border-[#E3E3E3] p-[24px] rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
              <div className="font-semibold text-[24px]">Dashboard</div>
              <div className="text-[#666666] font-normal">Welcome to the Traveler Dashboard</div>
            </div>

            {/* Verify NFTs Section - Mobile */}
            <div className="w-full lg:hidden mb-6">
              <div className={`w-full h-full flex flex-col space-y-[8px] sm:space-y-[10px] relative ${
                isOnboarding && currentStep === 18 ? 'ring-4 ring-purple-500 ring-opacity-50 shadow-2xl shadow-purple-500/50' : ''
              }`}>
                <div className="font-semibold">Verify NFTs</div>
                <div className="bg-white flex flex-col justify-around p-2 items-center border-[2px] h-full w-full border-[#E3E3E3] rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                  {currentProfile?.Avatar ? (
                    <img
                      alt=""
                      src={currentProfile?.Avatar || "/placeholder.svg"}
                      className="w-[80px] rounded-full shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                    />
                  ) : (
                    <VerifyUserIcon />
                  )}
                  {currentProfile?.Name ? (
                    <div className="font-semibold">{currentProfile?.Name?.replace("/", " ")}</div>
                  ) : (
                    <div className="font-semibold">Unknown</div>
                  )}
                  <div className="flex items-center gap-[10px]">
                    <UnVerified />
                    <div className="text-[#959595] font-normal text-[14px]">Unverified Account</div>
                  </div>
                  <div className="w-full">
                    <BlackButton text={<div className="w-full text-center">Verify now</div>} />
                  </div>
                </div>

                {/* Step 18 Verification Modal */}
                {isOnboarding && currentStep === 18 && (
                  <div className="absolute top-32 left-4 sm:left-4 sm:top-full sm:mt-4 lg:left-[320px] lg:top-0 w-[260px] bg-white rounded-lg shadow-2xl border-4 border-purple-500 z-[99999] onboarding-highlight pointer-events-auto">
                    <div className="p-3">
                      <div className="text-center mb-3">
                        <h3 className="text-base font-semibold">Verify Your Account</h3>
                        <p className="text-xs text-[#666666] mt-1">
                          Verifying your account unlocks full platform features and ensures security
                        </p>
                      </div>
                      <div className="bg-purple-50 p-2 rounded border border-purple-200 mb-3">
                        <div className="flex items-center gap-1 mb-1">
                          <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
                          <div className="text-xs font-semibold text-purple-800">Verification</div>
                        </div>
                        <div className="text-[10px] text-purple-700">
                          Connect your wallet and verify your identity to start booking and managing trips
                        </div>
                      </div>

                      <div className="onboarding-modal-buttons">
                        <BlackButton 
                          text="Back" 
                          onClick={() => {
                            setCurrentStep(17);
                            navigate('/onboarding/traveller?step=17');
                          }}
                          className="text-xs py-1.5 px-2 flex-1"
                        />
                        <PurpleButton 
                          text="Complete"
                          onClick={() => {
                            completeOnboarding();
                            localStorage.setItem('onboarding_completed', 'true');
                            navigate('/rent/onboarding/Completion');
                          }}
                          className="text-xs py-1.5 px-2 flex-1"
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* All Trips Section - Mobile */}
            <div className="w-full lg:hidden mb-6">
              <div className={`w-full h-full flex flex-col space-y-[8px] sm:space-y-[10px] relative ${
                isOnboarding && currentStep === 17 ? 'ring-4 ring-purple-500 ring-opacity-50 shadow-2xl shadow-purple-500/50' : ''
              }`}>
                <div className="font-semibold">All trips</div>
                <div className="border-[2px] border-[#E3E3E3] h-full bg-white p-2 top-0 overflow-auto w-full rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                  <div className="w-full justify-between flex items-center gap-4">
                    <SelectionGroup
                      defaultItem={flag}
                      className="border-[2px] border-[#e3e3e3] w-max px-[6px] py-[4px] gap-[8px] flex items-center rounded-[14px] bg-white shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                    >
                      <SelectionItem
                        SelectedItem={
                          <div className="py-[4px] cursor-pointer bg-white rounded-[10px] w-[120px] flex justify-center gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                            <div className="text-black font-semibold">Upcoming</div>
                            <LightIcon />
                          </div>
                        }
                        UnselectedItem={
                          <div className="py-[4px] cursor-pointer hover:bg-[#f6f6f6] rounded-[10px] w-[120px] flex justify-center">
                            <div className="text-[#959595]">Upcoming</div>
                          </div>
                        }
                      />
                      <SelectionItem
                        SelectedItem={
                          <div className="py-[4px] cursor-pointer bg-white rounded-[10px] w-[120px] flex justify-center gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                            <div className="text-black font-semibold">Current</div>
                            <LightIcon />
                          </div>
                        }
                        UnselectedItem={
                          <div className="py-[4px] cursor-pointer hover:bg-[#f6f6f6] rounded-[10px] w-[120px] flex justify-center">
                            <div className="text-[#959595]">Current</div>
                          </div>
                        }
                      />
                      <SelectionItem
                        SelectedItem={
                          <div className="py-[4px] cursor-pointer bg-white rounded-[10px] w-[120px] flex justify-center gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                            <div className="text-black font-semibold">Completed</div>
                            <LightIcon />
                          </div>
                        }
                        UnselectedItem={
                          <div className="py-[4px] cursor-pointer hover:bg-[#f6f6f6] rounded-[10px] w-[120px] flex justify-center">
                            <div className="text-[#959595]">Completed</div>
                          </div>
                        }
                      />
                      <SelectionItem
                        SelectedItem={
                          <div className="py-[4px] cursor-pointer bg-white rounded-[10px] w-[120px] flex justify-center gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                            <div className="text-black font-semibold">Cancelled</div>
                            <LightIcon />
                          </div>
                        }
                        UnselectedItem={
                          <div className="py-[4px] cursor-pointer hover:bg-[#f6f6f6] rounded-[10px] w-[120px] flex justify-center">
                            <div className="text-[#959595]">Cancelled</div>
                          </div>
                        }
                      />
                    </SelectionGroup>
                  </div>
                  <div className="flex gap-2 items-center mt-1 pb-1 w-full overflow-auto scrollbarwidth">
                    <div className="flex flex-col items-center w-full justify-center h-full">
                      <EmptyBooking />
                      <div>No trips yet</div>
                      <div className="text-[#737373]">No upcoming trips yet</div>
                    </div>
                  </div>
                </div>

                {/* Step 17 All Trips Modal */}
                {isOnboarding && currentStep === 17 && (
                  <div className="absolute -top-72 left-4 sm:left-4 sm:top-full sm:mt-4 lg:left-[320px] lg:top-0 w-[280px] bg-white rounded-lg shadow-2xl border-4 border-purple-500 z-[99999] onboarding-highlight pointer-events-auto">
                    <div className="p-3">
                      <div className="text-center mb-3">
                        <h3 className="text-base font-semibold">All Trips</h3>
                        <p className="text-xs text-[#666666] mt-1">
                          Here you can view all your upcoming, current, completed, and cancelled trips
                        </p>
                      </div>
                      <div className="bg-purple-50 p-2 rounded border border-purple-200 mb-3">
                        <div className="flex items-center gap-1 mb-1">
                          <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
                          <div className="text-xs font-semibold text-purple-800">Trip Management</div>
                        </div>
                        <div className="text-[10px] text-purple-700">
                          Easily manage and track your travel bookings from this panel
                        </div>
                      </div>
                      
                      <div className="onboarding-modal-buttons">
                        <BlackButton 
                          text="Back" 
                          onClick={() => {
                            setCurrentStep(16);
                            navigate('/onboarding/traveller?step=16');
                          }}
                          className="text-xs py-1.5 px-2 flex-1"
                        />
                        <PurpleButton 
                          text="Next"
                          onClick={() => {
                            setCurrentStep(18);
                            navigate('/onboarding/traveller?step=18');
                          }}
                          className="text-xs py-1.5 px-2 flex-1"
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Wishlist Section - Mobile */}
            <div className="w-full lg:hidden mb-6">
              <div className={`w-full h-full flex flex-col space-y-[8px] sm:space-y-[10px] relative ${
                isOnboarding && currentStep === 14 ? 'ring-4 ring-purple-500 ring-opacity-50 shadow-2xl shadow-purple-500/50' : ''
              }`}>
                <div className="font-semibold">Wishlist</div>
                <div className={`bg-white border-[2px] h-full w-full border-[#E3E3E3] p-[8px] rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] ${
                  isOnboarding && currentStep === 14 ? 'ring-2 ring-purple-400 ring-opacity-75 shadow-lg shadow-purple-400/30' : ''
                }`}>
                  <div className="pb-1 flex gap-[10px] items-center overflow-auto scrollbarwidth w-full">
                    {wishlistItems.map((item, i) => (
                      <div key={i} className="w-max h-max relative group">
                        <RentalItem
                          showArrow={false}
                          token_id={item.token_id}
                          tokenData={item}
                          imageHeight={200}
                          onlyImages
                        />
                      </div>
                    ))}
                  </div>
                </div>

       

{/* Step 14 Wishlist Modal - Mobile */}
{isOnboarding && currentStep === 14 && (
  <div className="absolute -top-72 left-4 sm:left-4 sm:-top-20 lg:left-[320px] lg:top-0 w-[280px] bg-white rounded-lg shadow-2xl border-4 border-purple-500 z-[99999] onboarding-highlight pointer-events-auto">
    <div className="p-3">
      <div className="text-center mb-3">
        <h3 className="text-base font-semibold">Wishlist & Favorites</h3>
        <p className="text-xs text-[#666666] mt-1">Save properties you love</p>
      </div>
      <div className="bg-purple-50 p-2 rounded border border-purple-200 mb-3">
        <div className="flex items-center gap-1 mb-1">
          <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
          <div className="text-xs font-semibold text-purple-800">Wishlist Features</div>
        </div>
        <div className="text-[10px] text-purple-700">
          Save properties for future bookings and easy access
        </div>
      </div>
      {/* Remove arrow for mobile, keep for desktop */}
      <div className="hidden lg:block absolute top-1/2 -left-4 w-0 h-0 border-r-[16px] border-t-[12px] border-b-[12px] border-r-purple-500 border-t-transparent border-b-transparent"></div>
      <div className="onboarding-modal-buttons">
        <BlackButton 
          text="Back" 
          onClick={() => {
            navigate('/onboarding/traveller?step=13');
            prevStep();
          }}
          className="text-xs py-1.5 px-2 flex-1"
        />
        <PurpleButton 
          text="Next"
          onClick={() => {
            navigate('/onboarding/traveller?step=15');
            nextStep();
          }}
          className="text-xs py-1.5 px-2 flex-1"
        />
        <button 
          onClick={handleSkipOnboarding}
          className="px-2 py-1.5 text-[10px] text-gray-500 hover:text-gray-700 rounded transition-colors"
        >
          Skip
        </button>
      </div>
    </div>
  </div>
)}


              </div>
            </div>

            {/* Notifications Section - Mobile */}
            <div className="w-full lg:hidden mb-6">
              <div className={`w-full h-full flex flex-col space-y-[8px] sm:space-y-[10px] relative ${
                isOnboarding && currentStep === 15 ? 'ring-4 ring-purple-500 ring-opacity-50 shadow-2xl shadow-purple-500/50' : ''
              }`}>
                <div className="font-semibold">Notifications</div>
                <div className={`bg-white flex flex-col justify-around items-center border-[2px] h-full w-full border-[#E3E3E3] p-[24px] rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] ${
                  isOnboarding && currentStep === 15 ? 'ring-2 ring-purple-400 ring-opacity-75 shadow-lg shadow-purple-400/30' : ''
                }`}>
                  <EmptyInbox />
                  <div className="flex flex-col items-center">
                    <div className="font-semibold">No notifications yet</div>
                    <div className="text-[#959595] font-normal text-[14px]">Your inbox is empty yet</div>
                  </div>
                  <PurpleButton text={<div className="min-w-[100px] text-center">Inbox</div>} />
                </div>

                {/* Step 15 Notifications Modal */}
                {isOnboarding && currentStep === 15 && (
                  <div className="absolute -top-72 left-4 sm:left-4 sm:top-full sm:mt-4 lg:left-[320px] lg:top-0 w-[280px] bg-white rounded-lg shadow-2xl border-4 border-purple-500 z-[99999] onboarding-highlight pointer-events-auto">
                    <div className="p-3">
                      <div className="text-center mb-3">
                        <h3 className="text-base font-semibold">Notifications & Inbox</h3>
                        <p className="text-xs text-[#666666] mt-1">Stay updated with platform alerts</p>
                      </div>
                      <div className="bg-purple-50 p-2 rounded border border-purple-200 mb-3">
                        <div className="flex items-center gap-1 mb-1">
                          <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
                          <div className="text-xs font-semibold text-purple-800">Communication Hub</div>
                        </div>
                        <div className="text-[10px] text-purple-700">
                          Stay updated with alerts about bookings, hosts, or platform news
                        </div>
                      </div>

                      <div className="onboarding-modal-buttons">
                        <BlackButton 
                          text="Back" 
                          onClick={() => {
                            navigate('/onboarding/traveller?step=14');
                            prevStep();
                          }}
                          className="text-xs py-1.5 px-2 flex-1"
                        />
                        <PurpleButton 
                          text="Next"
                          onClick={() => {
                            navigate('/onboarding/traveller?step=16');
                            nextStep();
                          }}
                          className="text-xs py-1.5 px-2 flex-1"
                        />
                        <button 
                          onClick={handleSkipOnboarding}
                          className="px-2 py-1.5 text-[10px] text-gray-500 hover:text-gray-700 rounded transition-colors"
                        >
                          Skip
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
</div>
        {/* Step 16 Header Modal */}
        {isOnboarding && currentStep === 16 && (
          <div className="fixed top-[100px] left-1/2 transform -translate-x-1/2 w-[300px] bg-white rounded-lg shadow-2xl border-4 border-purple-500 z-[99999] onboarding-highlight pointer-events-auto">
            <div className="p-4">
              <div className="text-center mb-3">
                <h3 className="text-base font-semibold">Top Navigation Bar</h3>
                <p className="text-xs text-[#666666] mt-1">Quick access to key features</p>
              </div>
              <div className="mb-3">
                <div className="text-xs font-semibold">You can quickly access:</div>
                <ul className="list-disc pl-5 text-sm text-[#666666]">
                  <li>Rent / Buy / Trade – Explore short stays, real estate purchases, or tokenized ownership</li>
                  <li>YieldEstate – View options for earning yield on property NFTs</li>
                  <li>Dashboard dropdown – Switch between dashboards depending on your role or journey</li>
                </ul>
              </div>
              <div className="absolute top-[-24px] left-1/2 transform -translate-x-1/2 w-0 h-0 border-b-[16px] border-l-[12px] border-r-[12px] border-b-purple-500 border-l-transparent border-r-transparent"></div>
              <div className="onboarding-modal-buttons mt-4">
                <BlackButton 
                  text="Back" 
                  onClick={() => {
                    navigate('/onboarding/traveller?step=15');
                    prevStep();
                  }}
                  className="text-xs py-1.5 px-2 flex-1"
                />
                <PurpleButton 
                  text="Next"
                  onClick={() => {
                    setCurrentStep(17);
                    navigate('/onboarding/traveller?step=17');
                  }}
                  className="text-xs py-1.5 px-2 flex-1"
                />
                <button 
                  onClick={handleSkipOnboarding}
                  className="px-2 py-1.5 text-[10px] text-gray-500 hover:text-gray-700 rounded transition-colors"
                >
                  Skip
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Confirmation Modal */}
        {showConfirmModal && (
          <Modal
            open={true}
            center
            onClose={cancelTourSwitch}
            showCloseIcon={false}
            classNames={{
              modal: "rounded-xl border-none shadow-2xl max-w-md w-full bg-white",
            }}
            styles={{
              modal: { 
                zIndex: 10000,
                backgroundColor: '#ffffff',
                background: '#ffffff',
              }
            }}
          >
            <div className="p-6 text-center bg-white">
              <h2 className="text-xl font-semibold mb-4">{pendingNavigation?.message}</h2>
              <div className="flex gap-4 justify-center mt-6">
                <BlackButton text="Skip" onClick={() => navigate('/dashboard/host/dashboard')} />
                <PurpleButton text="Yes, Continue" onClick={() => confirmTourSwitch(navigate)} />
              </div>
            </div>
          </Modal>
        )}
      </>
    ) : (
      <>
        {isOnboarding && currentStep === 13 && (
          <div className="absolute top-16 left-[320px] w-[280px] bg-white rounded-lg shadow-2xl border-4 border-purple-500 z-[99999] onboarding-highlight pointer-events-auto">
            <div className="p-3">
              <div className="text-center mb-3">
                <h3 className="text-base font-semibold">Navigation Sidebar</h3>
                <p className="text-xs text-[#666666] mt-1">Your menu for key features</p>
              </div>
              <div className="bg-purple-50 p-2 rounded-lg border border-purple-200 mb-3">
                <div className="flex items-center gap-1 mb-1">
                  <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
                  <div className="text-xs font-semibold text-purple-800">Traveler Navigation</div>
                </div>
                <div className="text-[10px] text-purple-700">
                  Your home base for traveling
                </div>
              </div>
              <div className="space-y-1 mb-3">
                <div className="flex items-center gap-2 p-1.5 bg-blue-50 rounded">
                  <div className="w-4 h-4 bg-blue-500 rounded-full flex items-center justify-center text-white">
                    <svg className="w-2 h-2" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
                    </svg>
                  </div>
                  <div>
                    <div className="text-xs font-semibold">Dashboard</div>
                    <div className="text-[10px] text-[#666666]">Home base</div>
                  </div>
                </div>
                <div className="flex items-center gap-2 p-1.5 bg-green-50 rounded">
                  <div className="w-4 h-4 bg-green-500 rounded-full flex items-center justify-center text-white">
                    <svg className="w-2 h-2" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <div>
                    <div className="text-xs font-semibold">Trips</div>
                    <div className="text-[10px] text-[#666666]">Bookings</div>
                  </div>
                </div>
                <div className="flex items-center gap-2 p-1.5 bg-yellow-50 rounded">
                  <div className="w-4 h-4 bg-yellow-500 rounded-full flex items-center justify-center text-white">
                    <svg className="w-2 h-2" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z" />
                    </svg>
                  </div>
                  <div>
                    <div className="text-xs font-semibold">Transactions</div>
                    <div className="text-[10px] text-[#666666]">Payments</div>
                  </div>
                </div>
                <div className="flex items-center gap-2 p-1.5 bg-red-50 rounded">
                  <div className="w-4 h-4 bg-red-500 rounded-full flex items-center justify-center text-white">
                    <svg className="w-2 h-2" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                      <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                    </svg>
                  </div>
                  <div>
                    <div className="text-xs font-semibold">Inbox</div>
                    <div className="text-[10px] text-[#666666]">Messages</div>
                  </div>
                </div>
              </div>
              <div className="bg-gradient-to-r from-purple-50 to-blue-50 p-2 rounded border border-purple-200 mb-3">
                <div className="flex items-center gap-1 mb-1">
                  <div className="w-2 h-2 bg-gradient-to-r from-purple-500 to-blue-500 rounded-full"></div>
                  <div className="text-xs font-semibold text-purple-800">Role Switcher</div>
                </div>
                <div className="text-[10px] text-purple-700">
                  🔄 Switch Host/Traveler at bottom
                </div>
              </div>
              <div className="absolute top-1/2 -left-4 w-0 h-0 border-r-[16px] border-t-[12px] border-b-[12px] border-r-purple-500 border-t-transparent border-b-transparent"></div>
              <div className="onboarding-modal-buttons">
                <BlackButton 
                  text="Back" 
                  onClick={() => {
                    prevStep();
                  }}
                  className="text-xs py-1.5 px-2 flex-1"
                />
                <PurpleButton 
                  text="Next"
                  onClick={() => {
                    navigate('/onboarding/traveller?step=14');
                    nextStep();
                  }}
                  className="text-xs py-1.5 px-2 flex-1"
                />
                <button 
                  onClick={handleSkipOnboarding}
                  className="px-2 py-1.5 text-[10px] text-gray-500 hover:text-gray-700 rounded transition-colors"
                >
                  Skip
                </button>
              </div>
            </div>
          </div>
        )}

        <div className={`relative ${
          isOnboarding && currentStep === 16 ? 'ring-4 ring-purple-500 ring-opacity-50 shadow-2xl shadow-purple-500/50' : ''
        }`}>
          {/* <Header/> */}
        </div>
        <div className="flex h-screen">
          {/* Add backdrop for step 13 (sidebar) */}
          {isOnboarding && currentStep === 13 && (
            <div className="fixed inset-0 bg-black bg-opacity-30 z-[99998] pointer-events-none" />
          )}
          {/* Add backdrop for step 14 (wishlist) */}
          {isOnboarding && currentStep === 14 && (
            <div className="fixed inset-0 bg-black bg-opacity-30 z-[99998] pointer-events-none" />
          )}
          {/* Add backdrop for step 15 (notifications) */}
          {isOnboarding && currentStep === 15 && (
            <div className="fixed inset-0 bg-black bg-opacity-30 z-[99998] pointer-events-none" />
          )}
          {/* Add backdrop for step 16 (header) */}
          {isOnboarding && currentStep === 16 && (
            <div className="fixed inset-0 bg-black bg-opacity-30 z-[99998] pointer-events-none" />
          )}

          {/* Highlight sidebar on onboarding step 13 */}
          <div className={`relative ${
            isOnboarding && currentStep === 13 ? 'ring-4 ring-purple-500 ring-opacity-50 shadow-2xl shadow-purple-500/50 z-[99998]' : ''
          }`}>
            <StaticTravelerSidebar />
          </div>

          <div className="flex-1 select-none w-full overflow-auto max-h-[calc(100vh-80px)] h-full p-[10px]">
            <div className="w-full h-full space-y-[20px] rounded-[10px] p-[8px] flex flex-col">
              <div className="bg-white border-[2px] h-max border-[#E3E3E3] p-[24px] rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                <div className="font-semibold text-[24px]">Dashboard</div>
                <div className="text-[#666666] font-normal">Welcome to the Traveler Dashboard</div>
              </div>

              <div className="flex gap-[20px] px-[10px] w-full min-h-[240px]">
                <div className="min-w-[300px] h-full flex flex-col space-y-[10px] relative">
                  <div className="font-semibold">Verify NFTs</div>
                  <div className="bg-white flex flex-col justify-around p-2 items-center border-[2px] h-full w-full border-[#E3E3E3] rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                    {currentProfile?.Avatar ? (
                      <img
                        alt=""
                        src={currentProfile?.Avatar || "/placeholder.svg"}
                        className="w-[80px] rounded-full shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                      />
                    ) : (
                      <VerifyUserIcon />
                    )}
                    {currentProfile?.Name ? (
                      <div className="font-semibold">{currentProfile?.Name?.replace("/", " ")}</div>
                    ) : (
                      <div className="font-semibold">Unknown</div>
                    )}
                    {currentProfile?.isVerified ? (
                      <div className="flex items-center gap-[10px]">
                        <div className="scale-75">
                          <Veified />
                        </div>
                        <div className="text-[#959595] font-normal text-[14px]">Verified Account</div>
                      </div>
                    ) : (
                      <div className="flex items-center gap-[10px]">
                        <UnVerified />
                        <div className="text-[#959595] font-normal text-[14px]">Unverified Account</div>
                      </div>
                    )}
                    <div className="w-full">
                      {currentProfile?.isVerified ? (
                        <PurpleButton text={<div className="w-full text-center">Your Profile</div>} />
                      ) : (
                        <BlackButton text={<div className="w-full text-center">Verify now</div>} />
                      )}
                    </div>
                  </div>

                  {isOnboarding && currentStep === 18 && (
                    <div className="absolute top-20 left-full ml-4 w-[320px] bg-white rounded-lg shadow-2xl border-4 border-purple-500 z-[99999] onboarding-highlight pointer-events-auto">
                      <div className="p-3">
                        <div className="text-center mb-3">
                          <h3 className="text-base font-semibold">Verify Your Account</h3>
                          <p className="text-xs text-[#666666] mt-1">
                            Verifying your account unlocks full platform features and ensures security
                          </p>
                        </div>
                        <div className="bg-purple-50 p-2 rounded border border-purple-200 mb-3">
                          <div className="flex items-center gap-1 mb-1">
                            <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
                            <div className="text-xs font-semibold text-purple-800">Verification</div>
                          </div>
                          <div className="text-[10px] text-purple-700">
                            Connect your wallet and verify your identity to start booking and managing trips
                          </div>
                        </div>

                        <div className="onboarding-modal-buttons">
                          <BlackButton 
                            text="Back" 
                            onClick={() => {
                              setCurrentStep(17);
                              navigate('/onboarding/traveller?step=17');
                            }}
                            className="flex-1 text-xs py-1.5 px-2"
                          />
                          <PurpleButton 
                            text="Complete"
                            onClick={() => {
                              completeOnboarding();
                              localStorage.setItem('onboarding_completed', 'true');
                              navigate('/rent/onboarding/Completion');
                            }}
                            className="flex-1 text-xs py-1.5 px-2"
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <div className="relative h-full max-w-[calc(50vw-200px)] w-max flex flex-col space-y-[10px]">
                  <div className="font-semibold">All trips</div>
                  <div className="border-[2px] border-[#E3E3E3] h-full bg-white p-2 top-0 overflow-auto w-full rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                    <div className="w-full min-w-[calc(50vw-240px)] justify-between flex items-center gap-4">
                      <SelectionGroup
                        defaultItem={flag}
                        className="border-[2px] border-[#e3e3e3] w-max px-[6px] py-[4px] gap-[8px] flex items-center rounded-[14px] bg-white shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                      >
                        <SelectionItem
                          SelectedItem={
                            <div className="py-[4px] cursor-pointer bg-white rounded-[10px] w-[120px] flex justify-center gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                              <div className="text-black font-semibold">Upcoming</div>
                              <LightIcon />
                            </div>
                          }
                          UnselectedItem={
                            <div className="py-[4px] cursor-pointer hover:bg-[#f6f6f6] rounded-[10px] w-[120px] flex justify-center">
                              <div className="text-[#959595]">Upcoming</div>
                            </div>
                          }
                        />
                        <SelectionItem
                          SelectedItem={
                            <div className="py-[4px] cursor-pointer bg-white rounded-[10px] w-[120px] flex justify-center gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                              <div className="text-black font-semibold">Current</div>
                              <LightIcon />
                            </div>
                          }
                          UnselectedItem={
                            <div className="py-[4px] cursor-pointer hover:bg-[#f6f6f6] rounded-[10px] w-[120px] flex justify-center">
                              <div className="text-[#959595]">Current</div>
                            </div>
                          }
                        />
                        <SelectionItem
                          SelectedItem={
                            <div className="py-[4px] cursor-pointer bg-white rounded-[10px] w-[120px] flex justify-center gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                              <div className="text-black font-semibold">Completed</div>
                              <LightIcon />
                            </div>
                          }
                          UnselectedItem={
                            <div className="py-[4px] cursor-pointer hover:bg-[#f6f6f6] rounded-[10px] w-[120px] flex justify-center">
                              <div className="text-[#959595]">Completed</div>
                            </div>
                          }
                        />
                        <SelectionItem
                          SelectedItem={
                            <div className="py-[4px] cursor-pointer bg-white rounded-[10px] w-[120px] flex justify-center gap-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                              <div className="text-black font-semibold">Cancelled</div>
                              <LightIcon />
                            </div>
                          }
                          UnselectedItem={
                            <div className="py-[4px] cursor-pointer hover:bg-[#f6f6f6] rounded-[10px] w-[120px] flex justify-center">
                              <div className="text-[#959595]">Cancelled</div>
                            </div>
                          }
                        />
                      </SelectionGroup>
                    </div>
                    <div className="flex gap-2 items-center mt-1 pb-1 w-full overflow-auto scrollbarwidth">
                      <div className="flex flex-col items-center w-full justify-center h-full">
                        <EmptyBooking />
                        <div>No trips yet</div>
                        <div className="text-[#737373]">No upcoming trips yet</div>
                      </div>
                    </div>
                  </div>

                  {isOnboarding && currentStep === 17 && (
                    <div className="absolute top-0 left-full ml-4 w-[320px] bg-white rounded-lg shadow-2xl border-4 border-purple-500 z-[99999] onboarding-highlight pointer-events-auto">
                      <div className="p-3">
                        <div className="text-center mb-3">
                          <h3 className="text-base font-semibold">All Trips</h3>
                          <p className="text-xs text-[#666666] mt-1">
                            Here you can view all your upcoming, current, completed, and cancelled trips
                          </p>
                        </div>
                        <div className="bg-purple-50 p-2 rounded border border-purple-200 mb-3">
                          <div className="flex items-center gap-1 mb-1">
                            <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
                            <div className="text-xs font-semibold text-purple-800">Trip Management</div>
                          </div>
                          <div className="text-[10px] text-purple-700">
                            Easily manage and track your travel bookings from this panel
                          </div>
                        </div>

                        <div className="onboarding-modal-buttons">
                          <BlackButton 
                            text="Back" 
                            onClick={() => {
                              setCurrentStep(16);
                              navigate('/onboarding/traveller?step=16');
                            }}
                            className="flex-1 text-xs py-1.5 px-2"
                          />
                          <PurpleButton 
                            text="Next"
                            onClick={() => {
                              setCurrentStep(18);
                              navigate('/onboarding/traveller?step=18');
                            }}
                            className="flex-1 text-xs py-1.5 px-2"
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="flex gap-[20px] px-[10px] w-full min-h-[300px]">
                <div className={`min-w-[40%] h-full flex flex-col space-y-[10px] relative ${
                  isOnboarding && currentStep === 14 ? 'ring-4 ring-purple-500 ring-opacity-50 shadow-2xl shadow-purple-500/50' : ''
                }`}>
                  <div className="font-semibold">Wishlist</div>
                  <div className={`bg-white border-[2px] h-full w-full border-[#E3E3E3] p-[8px] rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] ${
                    isOnboarding && currentStep === 14 ? 'ring-2 ring-purple-400 ring-opacity-75 shadow-lg shadow-purple-400/30' : ''
                  }`}>
                    <div className="pb-1 flex gap-[10px] items-center overflow-auto scrollbarwidth w-full">
                      {wishlistItems.map((item, i) => (
                        <div key={i} className="w-max h-max relative group">
                          <RentalItem
                            showArrow={false}
                            token_id={item.token_id}
                            tokenData={item}
                            imageHeight={200}
                            onlyImages
                          />
                        </div>
                      ))}
                    </div>
                  </div>

                  {isOnboarding && currentStep === 14 && (
                    <div className="absolute top-0 -right-[300px] w-[280px] bg-white rounded-lg shadow-2xl border-4 border-purple-500 z-[99999] onboarding-highlight pointer-events-auto">
                      <div className="p-3">
                        <div className="text-center mb-3">
                          <h3 className="text-base font-semibold">Wishlist & Favorites</h3>
                          <p className="text-xs text-[#666666] mt-1">Save properties you love</p>
                        </div>
                        <div className="bg-purple-50 p-2 rounded border border-purple-200 mb-3">
                          <div className="flex items-center gap-1 mb-1">
                            <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
                            <div className="text-xs font-semibold text-purple-800">Wishlist Features</div>
                          </div>
                          <div className="text-[10px] text-purple-700">
                            Save properties for future bookings and easy access
                          </div>
                        </div>
                        <div className="absolute top-1/2 -left-4 w-0 h-0 border-r-[16px] border-t-[12px] border-b-[12px] border-r-purple-500 border-t-transparent border-b-transparent"></div>
                        <div className="onboarding-modal-buttons">
                          <BlackButton 
                            text="Back" 
                            onClick={() => {
                              navigate('/onboarding/traveller?step=13');
                              prevStep();
                            }}
                            className="text-xs py-1.5 px-2 flex-1"
                          />
                          <PurpleButton 
                            text="Next"
                            onClick={() => {
                              navigate('/onboarding/traveller?step=15');
                              nextStep();
                            }}
                            className="text-xs py-1.5 px-2 flex-1"
                          />
                          <button 
                            onClick={handleSkipOnboarding}
                            className="px-2 py-1.5 text-[10px] text-gray-500 hover:text-gray-700 rounded transition-colors"
                          >
                            Skip
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <div className={`w-full h-full flex flex-col space-y-[10px] relative ${
                  isOnboarding && currentStep === 15 ? 'ring-4 ring-purple-500 ring-opacity-50 shadow-2xl shadow-purple-500/50' : ''
                }`}>
                  <div className="font-semibold">Notifications</div>
                  <div className={`bg-white flex flex-col justify-around items-center border-[2px] h-full w-full border-[#E3E3E3] p-[24px] rounded-[10px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] ${
                    isOnboarding && currentStep === 15 ? 'ring-2 ring-purple-400 ring-opacity-75 shadow-lg shadow-purple-400/30' : ''
                  }`}>
                    <EmptyInbox />
                    <div className="flex flex-col items-center">
                      <div className="font-semibold">No notifications yet</div>
                      <div className="text-[#959595] font-normal text-[14px]">Your inbox is empty yet</div>
                    </div>
                    <PurpleButton text={<div className="min-w-[100px] text-center">Inbox</div>} />
                  </div>

                  {isOnboarding && currentStep === 15 && (
                    <div className="absolute top-0 -left-[300px] w-[280px] bg-white rounded-lg shadow-2xl border-4 border-purple-500 z-[99999] onboarding-highlight pointer-events-auto">
                      <div className="p-3">
                        <div className="text-center mb-3">
                          <h3 className="text-base font-semibold">Notifications & Inbox</h3>
                          <p className="text-xs text-[#666666] mt-1">Stay updated with platform alerts</p>
                        </div>
                        <div className="bg-purple-50 p-2 rounded border border-purple-200 mb-3">
                          <div className="flex items-center gap-1 mb-1">
                            <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
                            <div className="text-xs font-semibold text-purple-800">Communication Hub</div>
                          </div>
                          <div className="text-[10px] text-purple-700">
                            Stay updated with alerts about bookings, hosts, or platform news
                          </div>
                        </div>
                        <div className="absolute top-1/2 -right-4 w-0 h-0 border-l-[16px] border-t-[12px] border-b-[12px] border-l-purple-500 border-t-transparent border-b-transparent"></div>
                        <div className="onboarding-modal-buttons">
                          <BlackButton 
                            text="Back" 
                            onClick={() => {
                              navigate('/onboarding/traveller?step=14');
                              prevStep();
                            }}
                            className="text-xs py-1.5 px-2 flex-1"
                          />
                          <PurpleButton 
                            text="Next"
                            onClick={() => {
                              navigate('/onboarding/traveller?step=16');
                              nextStep();
                            }}
                            className="text-xs py-1.5 px-2 flex-1"
                          />
                          <button 
                            onClick={handleSkipOnboarding}
                            className="px-2 py-1.5 text-[10px] text-gray-500 hover:text-gray-700 rounded transition-colors"
                          >
                            Skip
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {isOnboarding && currentStep === 16 && (
          <div className="fixed top-[100px] left-1/2 transform -translate-x-1/2 w-[300px] bg-white rounded-lg shadow-2xl border-4 border-purple-500 z-[99999] onboarding-highlight pointer-events-auto">
            <div className="p-4">
              <div className="text-center mb-3">
                <h3 className="text-base font-semibold">Top Navigation Bar</h3>
                <p className="text-xs text-[#666666] mt-1">Quick access to key features</p>
              </div>
              <div className="mb-3">
                <div className="text-xs font-semibold">You can quickly access:</div>
                <ul className="list-disc pl-5 text-sm text-[#666666]">
                  <li>Rent / Buy / Trade – Explore short stays, real estate purchases, or tokenized ownership</li>
                  <li>YieldEstate – View options for earning yield on property NFTs</li>
                  <li>Dashboard dropdown – Switch between dashboards depending on your role or journey</li>
                </ul>
              </div>
              <div className="absolute top-[-24px] left-1/2 transform -translate-x-1/2 w-0 h-0 border-b-[16px] border-l-[12px] border-r-[12px] border-b-purple-500 border-l-transparent border-r-transparent"></div>
              <div className="onboarding-modal-buttons mt-4">
                <BlackButton 
                  text="Back" 
                  onClick={() => {
                    navigate('/onboarding/traveller?step=15');
                    prevStep();
                  }}
                  className="text-xs py-1.5 px-2 flex-1"
                />
                <PurpleButton 
                  text="Next"
                  onClick={() => {
                    setCurrentStep(17);
                    navigate('/onboarding/traveller?step=17');
                  }}
                  className="text-xs py-1.5 px-2 flex-1"
                />
                <button 
                  onClick={handleSkipOnboarding}
                  className="px-2 py-1.5 text-[10px] text-gray-500 hover:text-gray-700 rounded transition-colors"
                >
                  Skip
                </button>
              </div>
            </div>
          </div>
        )}

        {showConfirmModal && (
          <Modal
            open={true}
            center
            onClose={cancelTourSwitch}
            showCloseIcon={false}
            classNames={{
              modal: "rounded-xl border-none shadow-2xl max-w-md w-full bg-white",
            }}
            styles={{
              modal: { 
                zIndex: 10000,
                backgroundColor: '#ffffff',
                background: '#ffffff',
              }
            }}
          >
            <div className="p-6 text-center bg-white">
              <h2 className="text-xl font-semibold mb-4">{pendingNavigation?.message}</h2>
              <div className="flex gap-4 justify-center mt-6">
                <BlackButton text="Skip" onClick={() => navigate('/dashboard/host/dashboard')} />
                <PurpleButton text="Yes, Continue" onClick={() => confirmTourSwitch(navigate)} />
              </div>
            </div>
          </Modal>
        )}
      </>
    )}
    </>
  )
}

export const StaticTravelerDashboard = TravelerDashboard

